import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { flowRight } from 'lodash'
import { useTranslation } from 'react-i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { getLocale } from 'lib/utils/getLocale'

import AlmaFooter from 'components/Alma/AlmaFooter/AlmaFooter'
import Link from 'components/Link'
import AppContext from 'components/AppContext'
import LanguageNavigation from 'components/Navigation/LanguageNavigation/LanguageNavigation'

import './app-footer.pcss'

const AppFooter = () => {
    const history = useHistory()
    const location = useLocation()

    const { t, i18n } = useTranslation()

    return (
        <AppContext context="footer">
            <footer className="app-footer color-light">
                <div className="app-footer__container">
                    <nav className="app-footer__nav">
                        <ul>
                            {/** <li><Link to="/faq" title={t('navigation.faq')} trackName="faq">{t('navigation.faq')}</Link></li> **/}
                            <li><Link to={`${getLocale(i18n.language)}/my-nettix-info`} title={t('navigation.myNettixInfo')} trackName="myNettixInfo">{t('navigation.myNettixInfo')}</Link></li>
                            <li><Link to={`${getLocale(i18n.language)}/fiksut-kaupat`} title={t('navigation.serviceProcess')} trackName="serviceProcess">{t('navigation.serviceProcess')}</Link></li>
                            <li><Link to={`${getLocale(i18n.language)}/ota-yhteytta`} title={t('navigation.contactUs')} trackName="contactUs">{t('navigation.contactUs')}</Link></li>
                        </ul>
                        <ul>
                            <li><Link to={`${getLocale(i18n.language)}/sahkoisen-kaupan-palveluehdot`} title={t('navigation.billOfSaleTermsAndConditions')} trackName="billOfSaleToS">{t('navigation.billOfSaleTermsAndConditions')}</Link></li>
                            <li>
                                <Link to={t('navigation.nettixTermsAndConditions.url')} title={t('navigation.nettixTermsAndConditions.text')} trackName="nettixToS">
                                    {t('navigation.nettixTermsAndConditions.text')}
                                </Link>
                            </li>
                            <li><Link to={`${getLocale(i18n.language)}/kauppakirjat`} title={t('navigation.salesContracts')} trackName="salesContracts">{t('navigation.salesContracts')}</Link></li>
                        </ul>
                    </nav>
                    <div className="app-footer__language-navigation">
                        <LanguageNavigation icon={true} history={history} location={location} />
                    </div>
                </div>
            </footer>
            <AlmaFooter />
        </AppContext>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
)(React.memo(AppFooter))
